import { Radio, RadioGroup, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
    option: {
        marginTop: 0,
        marginBottom: 0,
    },
    optionLabel: {
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.lineHeightBase300,
    },
    optionLabelSelected: {
        fontWeight: tokens.fontWeightSemibold,
    },
});

type ArchiveChoiceText = {
    remainingOptionText: string;
    allOptionText: string;
};

type ArchiveModeOptionsProps = {
    className: string;
    text: ArchiveChoiceText;
    selectedArchiveMode: string;
    onArchiveModeChange: (value: string) => void;
    disableRemainingOption?: boolean;
};

export const MultiMailArchiveModeOptions = ({
    className,
    text,
    selectedArchiveMode,
    onArchiveModeChange,
    disableRemainingOption = false,
}: ArchiveModeOptionsProps) => {
    const styles = useStyles();
    const remainingLabelClassName = mergeClasses(
        styles.optionLabel,
        selectedArchiveMode === 'remaining' ? styles.optionLabelSelected : undefined,
    );
    const allLabelClassName = mergeClasses(
        styles.optionLabel,
        selectedArchiveMode === 'all' ? styles.optionLabelSelected : undefined,
    );

    return (
        <RadioGroup className={className} value={selectedArchiveMode} onChange={(_event, data) => onArchiveModeChange(String(data.value))}>
            <Radio
                className={styles.option}
                value="remaining"
                label={{ className: remainingLabelClassName, children: text.remainingOptionText }}
                disabled={disableRemainingOption}
            />
            <Radio
                className={styles.option}
                value="all"
                label={{ className: allLabelClassName, children: text.allOptionText }}
            />
        </RadioGroup>
    );
};
